<template>
  <form
    class="text-center"
    action="https://www.paypal.com/cgi-bin/webscr"
    method="post"
    target="_top"
  >
    <input name="cmd" type="hidden" value="_s-xclick" />
    <input name="hosted_button_id" type="hidden" value="RS83Y6TWMX3EA" />
    <input
      alt="PayPal - The safer, easier way to pay online!"
      border="0"
      name="submit"
      src="https://www.paypalobjects.com/en_US/i/btn/btn_donateCC_LG.gif"
      type="image"
    />
    <img
      alt=""
      border="0"
      height="1"
      src="https://www.paypalobjects.com/en_US/i/scr/pixel.gif"
      width="1"
    />
  </form>
</template>
